export default {"src":"/_next/static/media/scope_icon_rgb_scope_green.507fdfb5.svg","height":395,"width":395,"blurWidth":0,"blurHeight":0};